import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36598d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timesheet-main" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Timesheet", -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_5 = {
  key: 0,
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_6 = { class: "approval-list-items" }
const _hoisted_7 = { class: "approval-list-heading" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Timesheet approval", -1))
const _hoisted_9 = {
  key: 0,
  class: "fal fa-exclamation-triangle fa-lg mr-2"
}
const _hoisted_10 = { class: "hide-button" }
const _hoisted_11 = {
  key: 0,
  class: "fal fa-angle-up"
}
const _hoisted_12 = {
  key: 1,
  class: "fal fa-angle-down"
}
const _hoisted_13 = { class: "timesheet-approval-table" }
const _hoisted_14 = { class: "ls-table" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { "data-label": "Duration" }
const _hoisted_23 = { "data-label": "Complete time" }
const _hoisted_24 = { "data-label": "Missing time" }
const _hoisted_25 = { "data-label": "Annual/Personal Leave" }
const _hoisted_26 = { "data-label": "Public holidays" }
const _hoisted_27 = {
  key: 0,
  "data-label": "Actions"
}
const _hoisted_28 = { class: "timesheet-table mt-2" }
const _hoisted_29 = { class: "ls-table" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["colspan"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["colspan"]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["colspan"]
const _hoisted_36 = { "data-label": "Date" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { "data-label": "Name" }
const _hoisted_40 = { "data-label": "Details" }
const _hoisted_41 = { "data-label": "Firm name" }
const _hoisted_42 = { "data-label": "Reference" }
const _hoisted_43 = { "data-label": "Break" }
const _hoisted_44 = { "data-label": "Work hours" }
const _hoisted_45 = { "data-label": "Actions" }
const _hoisted_46 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_DateController = _resolveComponent("DateController")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DateController, {
          style: {"min-width":"550px"},
          onGetTimePeriod: _ctx.getTimePeriod,
          onPrev: _ctx.prev,
          onNext: _ctx.next,
          onToday: _ctx.today,
          onUpdate: _ctx.updateDisplay
        }, null, 8, ["onGetTimePeriod", "onPrev", "onNext", "onToday", "onUpdate"]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-primary mr-2",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.exportTimeSheet()))
          }, "Export")
        ])
      ])
    ]),
    (!_ctx.loadingTimesheetApprovals && !_ctx.errorLoadingTimesheetApprovals)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["approval-list", _ctx.timesheetApproved(_ctx.timesheetApproval) ? 'timesheet-approved' : 'timesheet-not-approved'])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, [
                  (!_ctx.timesheetApproved(_ctx.timesheetApproval))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("h4", null, _toDisplayString(_ctx.timesheetApproved(_ctx.timesheetApproval) ? "All timesheets approved"
              : "Pending approval"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-secondary sml mr-2",
                  onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showHideTSApproval && _ctx.showHideTSApproval(...args)))
                }, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.showTimesheetApproval ? 'Hide' : 'Show'), 1),
                    (_ctx.showTimesheetApproval)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                      : (_openBlock(), _createElementBlock("i", _hoisted_12))
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheetApprovalHeadings, (h, index) => {
                      return (_openBlock(), _createElementBlock("th", null, [
                        _createElementVNode("p", null, _toDisplayString(h.text), 1)
                      ]))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.loadingTimesheetApprovals)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                        _createElementVNode("td", {
                          colspan: _ctx.timesheetApprovalHeadings.length
                        }, [
                          _createVNode(_component_LoadingIndicator)
                        ], 8, _hoisted_16)
                      ]))
                    : (_ctx.errorLoadingTimesheetApprovals)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                          _createElementVNode("td", {
                            colspan: _ctx.timesheetApprovalHeadings.length
                          }, [
                            _createVNode(_component_ErrorIndicator)
                          ], 8, _hoisted_18)
                        ]))
                      : (!_ctx.loadingTimesheetApprovals && !_ctx.errorLoadingTimesheetApprovals && _ctx.timesheetApproval.missingTime === null)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                            _createElementVNode("td", {
                              colspan: _ctx.timesheetApprovalHeadings.length
                            }, "No Records", 8, _hoisted_20)
                          ]))
                        : (!_ctx.loadingTimesheetApprovals && !_ctx.errorLoadingTimesheetApprovals)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.timesheetApproval.duration), 1),
                              _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$calculateHours(_ctx.timesheetApproval.completeTime)), 1),
                              _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$calculateHours(_ctx.timesheetApproval.missingTime)), 1),
                              _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$calculateHours(_ctx.timesheetApproval.annualLeaveTime +
                  _ctx.timesheetApproval.personalLeaveTime)), 1),
                              _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$calculateHours(_ctx.timesheetApproval.publicHolidayTime)), 1),
                              (_ctx.timesheetApproval.timesheetStatus.id === 2)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                    _createElementVNode("button", {
                                      class: "btn btn-default sml ma-1",
                                      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.approveTimeEntries && _ctx.approveTimeEntries(...args)))
                                    }, " Approve ")
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                ])
              ])
            ], 512), [
              [_vShow, _ctx.showTimesheetApproval]
            ])
          ], 2),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheetEntryHeadings, (h, index) => {
                    return (_openBlock(), _createElementBlock("th", null, [
                      _createElementVNode("p", null, _toDisplayString(h.text), 1)
                    ]))
                  }), 256))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loadingTimeEntries)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                      _createElementVNode("td", {
                        colspan: _ctx.timesheetEntryHeadings.length
                      }, [
                        _createVNode(_component_LoadingIndicator)
                      ], 8, _hoisted_31)
                    ]))
                  : (_ctx.errorLoadingTimeEntries)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                        _createElementVNode("td", {
                          colspan: _ctx.timesheetEntryHeadings.length
                        }, [
                          _createVNode(_component_ErrorIndicator)
                        ], 8, _hoisted_33)
                      ]))
                    : (!_ctx.loadingTimeEntries && !_ctx.errorLoadingTimeEntries && _ctx.timesheetEntries?.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                          _createElementVNode("td", {
                            colspan: _ctx.timesheetEntryHeadings.length
                          }, "No Records", 8, _hoisted_35)
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.timesheetEntries, (t) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass(t.id == 0 ? 'missing-entry' : '')
                          }, [
                            _createElementVNode("td", _hoisted_36, [
                              (t.id == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$formatDate(t.startDateTime)) + " (" + _toDisplayString(_ctx.$calculateHours(t.missingTime)) + " missing)", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$formatDateTimeTypeA(t.startDateTime)) + " - " + _toDisplayString(_ctx.$formatDateTimeTypeA(t.endDateTime)), 1))
                            ]),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(t.id == 0 ? '' : _ctx.$getTimeEntryTypeName(t.timeEntryType.id, _ctx.timeEntryType)), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(t.id == 0 ? '' : _ctx.$getDetails(t)), 1),
                            _createElementVNode("td", _hoisted_41, _toDisplayString(t.id == 0 ? '' : _ctx.$getFirmName(t)), 1),
                            _createElementVNode("td", _hoisted_42, _toDisplayString(t.id == 0 ? '' : _ctx.$getReference(t)), 1),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.$getBreakHours(t)), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$getWorkHours(t)), 1),
                            _createElementVNode("td", _hoisted_45, [
                              (t.id !== 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-default sml ma-1",
                                    onClick: $event => (_ctx.addEditTimesheet(t))
                                  }, " View event ", 8, _hoisted_46))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 256))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}